import { css } from '@emotion/react'
import { Cell, Text, VFlow } from 'bold-ui'
import { NumberField, TextField } from 'components/form'
import { usePecField } from 'components/form/core/hooks/useField'
import { Fragment } from 'react'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel } from '../../../model-prescricao'

interface FornecimentoFieldsCellsSectionProps {
  name: MetaRoot<MedicamentoFormModel>
}
export const FornecimentoFieldsCellsSection = (props: Readonly<FornecimentoFieldsCellsSectionProps>) => {
  const { name } = props

  const { input: registroManualInput } = usePecField({ name: name.registroManual, subscription: { value: true } })
  const isRegistroManual = registroManualInput.value

  const { input: principioAtivoInput } = usePecField({ name: name.principioAtivoCombo, subscription: { value: true } })
  const principioAtivoCombo = principioAtivoInput.value

  return (
    <Fragment>
      <Cell size={4} data-cy='Quantidade'>
        <NumberField
          name={name.quantidade}
          label='Quantidade solicitada'
          required
          maxLength={3}
          data-cy='QuantidadeTextField'
        />
      </Cell>
      <Cell size={6} style={styles.textAlignLeft} data-cy='UnidadadeFornecimento'>
        {!isRegistroManual ? (
          <VFlow vSpacing={0}>
            <Text fontWeight='bold'>Unidade de fornecimento</Text>
            <Text data-cy='UnidadadeFornecimentoLabel'>{principioAtivoCombo?.unidadeFornecimento?.nome ?? '-'}</Text>
          </VFlow>
        ) : (
          <TextField
            name={name.unidadeFornecimento}
            label='Unidade de fornecimento'
            required
            minLength={2}
            maxLength={100}
            data-cy='UnidadadeFornecimentoTextField'
          />
        )}
      </Cell>
    </Fragment>
  )
}

const styles = {
  textAlignLeft: css`
    text-align: left;
  `,
}
